const theme = {
  primary: '#7D3DAE',
  primaryDark: '#270438',
  secondary: '#CB1D8D',
  secondaryLight: '#270438',
  primaryLight: '#BFB8C2',
  primaryLight2: '#F7F7F8',
  primaryLight3: '#c4e4fa',
  cyan: '#5BC2B6',
  primaryDisabled: '#EDEDED',
  headingColor: '#0A0509',
  body: '#000000',
  textColor: '#585558',
  gray10: '#FAFAFB',
  gray20: '#0302292b',
  gray40: '#03022969',
  gray60: '#1E1E1E99',
  gray70: '#030229B2',
  gray80: '#030229CC',
  grayNew: '#030229',
  darkenText: '#270438',
  textLightColor: '#7E7E7E',
  placeholderColor: '#93829C',
  grayBg: '#D9D9D9',
  lightGray: '#FCFCFC',
  lightHover: '#7D3DAE0C',
  inputDisabled: '#707070',
  inputBorder: '#EFEFEF',
  bodyBg: '#F5F5F5',
  hoverColor: '#fafafa',
  white: '#ffffff',
  inputPlaceHolder: '#9A9FA5',
  borderColor: '#E0E0E0',
  inputColor: '#787377',
  success: '#76CC57',
  success2: '#4BB543',
  success3: '#05b7141a',
  success4: '#28C66F',
  danger: '#bb2124',
  danger2: '#CC5757',
  danger3: '#cc57571a',
  danger4: '#B80000',
  blue: '#6d78d0',
  warning: '#FFD307',
  warning2: '#FFCC01',
  paginationBorder: '#DADADA',
  mainPrimary: '#7D3DAE',
  lightGray1: '#EFEFEF',
  lightGray2: '#FBF8FF',
  menuText: '#03022966',
  placeholder: '#B5B5B5',
  gray: '#747474',
  sectionBorder: '#EFEFEF',
  badgeBgLight: '#FFEFFC',
  badgeText: '#C6009C',
  badgeTextLight: '#C6009C1A',
  borderColorLight: '#E3E3E3',
  iconColor: '#BDBDBD',
  yellow: '#FDCC0D',
  transparent: 'transparent',
  breakpoints: {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
  },
  dark10: '#1A1515',
  dark20: '#1E1E1E',
  dark30: '#323232',
  dark40: '#646567',
  dark50: '#A5A6A8',
  dark60: '#B8B8B8',
  dark70: '#D8D8D8',
  dark80: '#EDEDED',
  dark90: '#F2F2F2',
  dark95: '#F9F9F9',
  bodyMedium: '#666467',
  heading: '#1B131F',
  boldHeading: '#13151F',
  bodyLight: '#B4B2B5',
  icon: '#260735',
  fontFamily: 'Instrument Sans',
  primaryGreen: '#62AA48',
  primaryGreen1: '#182911',
  primaryGreen2: '#27441D',
  primaryGreen3: '#3B662B',
  primaryGreen4: '#4F883A',
  primaryGreen5: '#76CC57',
  primaryGreen6: '#8DD473',
  primaryGreen7: '#BAE5AB',
  primaryGreen8: '#D1EEC7',
  primaryGreen9: '#E3F5DD',
  primaryGreen10: '#F0FFEB',
  error: '#D95454',
  successTag: '#48AA5E',
  dangerTag: '#AE3D3D',
  info: '2C99F',
};

export default theme;
